import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSnackBar } from '@angular/material/snack-bar';
import {
  AnalyticsLoggerService,
  GENERAL_EVENTS,
} from 'src/app/services/analytics-logger.service';
import { environment } from 'src/environments/environment';
import { AuthService } from 'src/services/auth/auth.service';

@Component({
  selector: 'cover-signup',
  standalone: true,
  imports: [
    MatIconModule,
    MatButtonModule,
    MatInputModule,
    FormsModule,
    CommonModule,
  ],
  templateUrl: './cover-signup.component.html',
  styleUrl: './cover-signup.component.scss',
})
export class CoverSignupComponent {
  env = environment;

  @Input() isForLogin = false;

  @Output() onLoginClick = new EventEmitter();
  @Output() onSignupClick = new EventEmitter();
  @Output() onBackClick = new EventEmitter();

  email: string = '';
  password: string = '';
  isSubmitButtonLoading = false;

  constructor(
    public authService: AuthService,
    private _matSnackbar: MatSnackBar,
    private logger: AnalyticsLoggerService
  ) {}

  async loginOrSignUp(email: string, password: string) {
    if (this.isForLogin) {
      await this.login(email, password);
    } else {
      await this.signup(email, password);
    }
  }

  async login(email: string, password: string) {
    try {
      this.isSubmitButtonLoading = true;
      await this.authService.loginWithEmailAndPassword(email, password);
      this.logger.logEvent(GENERAL_EVENTS.userLogin);
      window.location.reload();
    } catch (e: any) {
      this._matSnackbar.open(`Error: ${e.message}`);
    } finally {
      this.isSubmitButtonLoading = false;
    }
  }

  async signup(email: string, password: string) {
    try {
      this.isSubmitButtonLoading = true;
      await this.authService.signupWithEmail(email, password);
      this.logger.logEvent(GENERAL_EVENTS.userSignup);
      window.location.reload();
    } catch (e: any) {
      this._matSnackbar.open(`Error: ${e.message}`);
    } finally {
      this.isSubmitButtonLoading = false;
    }
  }

  async continueWithGoogle() {
    try {
      await this.authService.continueWithGoogle();
      this.logger.logEvent(GENERAL_EVENTS.userSignup);
      window.location.reload();
    } catch (e: any) {
      this._matSnackbar.open(`Error: ${e.message}`);
    }
  }
}
